import './index.less';
import empty from '@/assets/empty/space.svg';
import slideFile from '@/assets/assets/slide-file.png';
import { useEffect, useState, useRef } from 'react';
import { Space as SpaceAPI, assetController } from '@/api/index';
import { useDashboardData } from '@/hooks/DashboardHooks';
import { formatMilliseconds, timeDiffFromNow } from '@/utils/dayjs';
import { useTranslation } from 'react-i18next';
import Icon from '@/components/iconfont/Icon.jsx';
import Aivoices from './components/vioces/index';
import download from '@/assets/space/download.png';
// import download2 from '@/assets/space/download2.png';
import RcPagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import AiVoiceList from './components/aivioceslist';
export default function Space() {
  return (
    <div className="space_box">
      <Materials />
      {/*<Exported />*/}
    </div>
  );
}
function Materials() {
  const { t } = useTranslation();
  const tablist = [
    'As_Edit_SpaceTabDraft334',
    'As_Edit_SpaceTabExported334',
    'As_Edit_SpaceTabMyVoice334',
    'As_Edit_SpaceTabDefaultVoice334',
  ];
  const [tabActive, setTabActive] = useState(0);
  const [cardList, setCardList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({ pageIndex: 0, pageSize: 12, total: 0 });
  const [showType, setShowType] = useState(0);
  const getData = async () => {
    let res;
    setLoading(true);
    try {
      switch (tabActive) {
        case 0:
          // 用户素材
          res = await SpaceAPI.originalVideo({ ...pageInfo, type: 2 });
          break;
        case 1:
          // 导出的视频
          res = await SpaceAPI.originalVideo({ ...pageInfo, type: 3 });
          break;
        case 2:
          // 用户音色
          res = await SpaceAPI.userVoice(pageInfo);
          break;
        case 3:
          // AI音色
          console.log(pageInfo);
          res = await SpaceAPI.aiVoice(pageInfo);
          break;
        default:
          break;
      }
      if (res.code === 0) {
        const info = res.data.result;
        setCardList(info?.rows || []);
        setPageInfo((page) => ({
          ...page,
          total: info?.totalRowCount || 0,
        }));
        setShowType(res.data.type);
      }
      if (res.data.result.rows.length <= 0 && pageInfo.pageIndex !== 0) {
        setPageInfo((page) => ({ ...page, pageIndex: page.pageIndex - 1 }));
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, [tabActive, pageInfo.pageIndex, pageInfo.pageSize]);
  const handleTabChange = (index) => {
    setTabActive(index);
    setPageInfo({ pageIndex: 0, pageSize: 12, total: 0 });
  };
  const handlePagChange = (pageIndex, pageSize) => {
    setPageInfo((page) => ({
      ...page,
      pageIndex: pageIndex - 1,
      pageSize,
    }));
  };
  return (
    <div className="materials">
      <div className="materials_title">{t('As_Space_Checkprojects')}</div>
      <div className="assets_tab_box">
        <div className="tab_box">
          {tablist.map((res, index) => (
            <button
              className={`btn btn-ghost tabitem ${index == tabActive ? 'tabitem_active' : ''}`}
              onClick={() => handleTabChange(index)}
              key={index}>
              {t(res)}
            </button>
          ))}
        </div>
      </div>
      <div className="data_show">
        {loading ? (
          <div className="loading_main">
            <span className="loading loading-spinner loading-md text-neutral"></span>
          </div>
        ) : tabActive == 0 && showType - 1 == tabActive ? (
          <AssetsVideo list={cardList} assetsList={getData} />
        ) : tabActive == 1 && showType == tabActive ? (
          <AssetsVideo list={cardList} assetsList={getData} asExportist />
        ) : tabActive == 2 && showType == tabActive ? (
          <Aivoices voiceList={cardList} setVoiceList={setCardList} getlist={getData} />
        ) : tabActive == 3 && showType == tabActive ? (
          <AiVoiceList list={cardList} />
        ) : (
          <div className="loading_main">
            <span className="loading loading-spinner loading-md text-neutral"></span>
          </div>
        )}
        <div style={{ height: '20px' }}></div>
        {pageInfo.total > 12 && (
          <RcPagination
            current={pageInfo.pageIndex + 1}
            defaultPageSize={pageInfo.pageSize}
            total={pageInfo.total}
            align="center"
            onChange={handlePagChange}
            showTitle={false}
            prevIcon={
              <button className={`rc-flip ${pageInfo.pageIndex === 0 && 'rc-disabled-flip'}`} />
            }
            nextIcon={
              <button
                className={`rc-flip ${pageInfo.pageIndex + 1 === Math.ceil(pageInfo.total / pageInfo.pageSize) && 'rc-disabled-flip'}`}
              />
            }
          />
        )}
      </div>
    </div>
  );
}
// 视频资源组件
function AssetsVideo({ list, assetsList, asExportist }) {
  const popState = useRef(false);
  const setPopState = (state) => {
    popState.current = state;
  };
  return (
    <div className="assets_list_content">
      {list?.length > 0 ? (
        list.map((item, index) => (
          <ItemCard
            type="video"
            key={index}
            item={item}
            assetsList={assetsList}
            asExportist={asExportist}
            popState={popState}
            setPopState={setPopState}
          />
        ))
      ) : (
        <EmptyAssets text="As_Home_ProjectNull1334" text2="As_Home_ProjectNull2334" />
      )}
    </div>
  );
}
// // 幻灯片资源组件
// function AssetsSlides({ list, assetsList }) {
//   return (
//     <div className="assets_list_content">
//       {list?.length > 0 ? (
//         list.map((item, index) => (
//           <ItemCard type="slides" key={index} item={item} assetsList={assetsList} />
//         ))
//       ) : (
//         <EmptyAssets text="As_Remind_LocalDes3" />
//       )}
//     </div>
//   );
// }
// 资源项卡片组件
function ItemCard({ type, item, assetsList, asExportist, popState, setPopState }) {
  const [itemData, setItemData] = useState(JSON.parse(JSON.stringify(item)));
  const inputRef = useRef(null);
  const PopUpRef = useRef(null);
  const [previewImgList, setPreviewImgList] = useState([]);
  const [previewImgIndex, setPreviewImgIndex] = useState(1);
  const { setChildCallback } = useDashboardData();
  const { t } = useTranslation();
  useEffect(() => {
    setItemData(JSON.parse(JSON.stringify(item)));
  }, [item]);
  const itemCardStatus = () => {
    if (item.status > 0) return;
    if (type === 'slides') {
      return (
        <div className="option_edit">
          <div className="text">
            <img className="text_img" src={slideFile} alt="" />
            <div className="spot_box">
              {/* Processing to slides */}
              {t('As_Home_ProjectState1')}
              <span className="spot_list">
                <span className="spot">·</span>
                <span className="spot">·</span>
                <span className="spot">·</span>
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="option_edit">
          <div className="text1">
            {/* Processing to slides... */}
            {t('As_Home_ProjectState1')}...
          </div>
        </div>
      );
    }
  };

  const handleDelete = async () => {
    await assetController.delete({ assetId: item.id });
    assetsList();
    setChildCallback(new Date().getTime());
  };

  const handleEditName = () => {
    setItemData((prev) => ({ ...prev, editShow: true }));
    mouseLeaveClose();
  };

  const mouseLeaveClose = () => {
    setItemData((prev) => ({ ...prev, isOpen: false }));
  };

  const mouseHoverShow = () => {
    setItemData((prev) => ({ ...prev, isOpen: true }));
  };

  const handleChangeName = (e) => {
    setItemData((prev) => ({ ...prev, name: e.target.value }));
  };

  const handleEditEnd = async () => {
    if (!itemData.name) {
      setItemData((prev) => ({ ...prev, editShow: false }));
      assetsList();
      return;
    }
    await assetController.rename({
      assetId: item.id,
      body: {
        newName: itemData.name,
      },
    });
    assetsList();
  };

  useEffect(() => {
    if (itemData.editShow && inputRef.current) {
      inputRef.current.focus();
    }
  }, [itemData.editShow]);
  useEffect(() => {
    // 监听 dialog 关闭事件
    const handleDialogClose = () => {
      if (type === 'video') {
        const video = PopUpRef.current?.querySelector('video');
        if (video) {
          video.pause();
        }
        setPopState && setPopState(false);
      }
    };

    const dialogElement = PopUpRef.current;
    dialogElement?.addEventListener('close', handleDialogClose);

    return () => {
      dialogElement?.removeEventListener('close', handleDialogClose);
    };
  }, [type]);

  const VideoPupUp = () => {
    if (type === 'video') {
      return (
        <dialog id="my_modal_2" ref={PopUpRef} className="modal">
          <div className="modal-box min-w-[960px]">
            <video src={itemData.url} controls></video>
          </div>
          <form method="dialog" className="modal-backdrop">
            <button>close</button>
          </form>
        </dialog>
      );
    } else {
      return (
        <dialog id="my_modal_2" ref={PopUpRef} className="modal ppt_modal">
          <div className="modal-box min-w-[960px]">
            <div className="ppt_img">
              <img src={previewImgList[previewImgIndex - 1]?.url} alt="" />
            </div>
            <div className="ppt_btn">
              <button onClick={handleFirst} className="btn btn-secondary btn-sm">
                <Icon name="icon-to-left" />
              </button>
              <button onClick={handlePrev} className="btn btn-secondary btn-sm ml-[20px]">
                <Icon name="icon-arrow-left" />
              </button>
              <div className="pagination_box">
                {previewImgIndex}/{previewImgList?.length}
              </div>
              <button onClick={handleNext} className="btn btn-secondary btn-sm mr-[20px]">
                <Icon name="icon-arrow-right" />
              </button>
              <button onClick={handleLast} className="btn btn-secondary btn-sm">
                <Icon name="icon-to-right" />
              </button>
            </div>
          </div>

          <form method="dialog" className="modal-backdrop">
            <button>close</button>
          </form>
        </dialog>
      );
    }
  };

  const handleFirst = () => {
    setPreviewImgIndex(1);
  };

  const handlePrev = () => {
    if (previewImgIndex <= 1) {
      setPreviewImgIndex(1);
    } else {
      setPreviewImgIndex(previewImgIndex - 1);
    }
  };

  const handleNext = () => {
    if (previewImgIndex >= previewImgList?.length) {
      setPreviewImgIndex(previewImgList?.length);
    } else {
      setPreviewImgIndex(previewImgIndex + 1);
    }
  };

  const handleLast = () => {
    setPreviewImgIndex(previewImgList?.length);
  };

  const handlePreview = async () => {
    if (item.status <= 0 || popState?.current) {
      return;
    }
    setPopState && setPopState(true);
    // window.onClickGATrackEvent('project-view', {
    //   project_id: item.id,
    // });
    const res = await assetController.detail({ assetId: item.id });
    if (res.code === 0) {
      setPreviewImgList(res.data);
    }
    PopUpRef.current.show();
  };
  const handleDownload = async () => {
    try {
      location.href = itemData.url;
    } catch (error) {
      console.error('下载失败:', error);
    }
  };
  return (
    <div className="project_item">
      <div className="top">
        <img className="project_img" src={itemData.thumbnail} alt="" />
        {type === 'video' && (
          <div className="options_box">
            {formatMilliseconds(itemData.duration || itemData.size || 0)}
          </div>
        )}
        {!asExportist && itemData.status !== 0 && (
          <div className="preview_box" onClick={handlePreview}>
            <Icon name="icon-view" className="preview_icon" />
            {/* Preview */}
            {t('As_ProjectManage_PreviewView')}
          </div>
        )}
        {asExportist && itemData.status !== 0 && (
          <div className="preview_box" onClick={handleDownload}>
            <img src={download} className="download_img" />
            {/* Download */}
            {t('As_Preview_Download')}
          </div>
        )}
        {itemCardStatus()}
      </div>
      <div className="btm">
        <div className="project_information">
          <div className="project_name">
            {itemData.editShow ? (
              <input
                ref={inputRef}
                type="text"
                defaultValue={itemData.name}
                onChange={handleChangeName}
                onBlur={handleEditEnd}
                maxLength={200}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
                placeholder=""
                className="input input-bordered w-full input-xs"
              />
            ) : (
              <div className="show_name">{itemData.name}</div>
            )}
          </div>
          <div className="last_time">
            Last updated {timeDiffFromNow(itemData.gmtModified || itemData.exportTime)}
          </div>
        </div>
        <div
          className="dropdown dropdown-end dropdown-open z-[3] lookList"
          id={`dropdown-${itemData.id}`}
          onMouseEnter={() => mouseHoverShow()}
          onMouseLeave={() => mouseLeaveClose()}>
          <Icon tabIndex={0} name="icon-dot-more-vertically" className="right_more" />
          {itemData.isOpen && (
            <>
              <div
                style={{
                  width: '180px',
                  height: '5px',
                  background: 'transparent',
                  marginLeft: '-140px',
                  position: 'absolute',
                }}
              />
              <ul
                tabIndex={0}
                onMouseLeave={() => mouseLeaveClose()}
                className="dropdown-content bg-base-100 rounded-box z-[3] w-52 p-2 shadow spaceCard_mean">
                {!asExportist && item.status > 0 && (
                  <li onClick={handlePreview}>
                    <a className="drop_item">
                      <Icon name="icon-view" className="drop_icon" />
                      {/* Preview */}
                      {t('As_ProjectManage_PreviewView')}
                    </a>
                  </li>
                )}
                {asExportist && item.status > 0 && (
                  <li onClick={handleDownload}>
                    <a className="drop_item">
                      <Icon name="icon-download" className="drop_icon" />
                      {/*<img src={download2} className="download_drop" />*/}
                      {t('As_Preview_Download')}
                    </a>
                  </li>
                )}
                <li onClick={handleEditName}>
                  <a className="drop_item">
                    <Icon name="icon-edit" className="drop_icon" />
                    {/* Rename */}
                    {t('As_ProjectManage_Rename')}
                  </a>
                </li>
                <li onClick={handleDelete}>
                  <a className="drop_item">
                    <Icon name="icon-delete" className="drop_icon" />
                    {/* Delete */}
                    {t('As_ProjectManage_Delete')}
                  </a>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
      {VideoPupUp()}
    </div>
  );
}
// 空资源显示组件
function EmptyAssets({ text, text2 }) {
  const { t } = useTranslation();
  return (
    <div className="empty_assets">
      <img className="empty_img" src={empty} alt="" />
      <div className="text">{t(text)}</div>
      <div className="text">{t(text2)}</div>
    </div>
  );
}
// function Exported() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [videoList, setVideoList] = useState([]);
//   const [pageInfo, setPageInfo] = useState({ pageIndex: 0, pageSize: 12, total: 0 });
//   useEffect(() => {
//     getList();
//   }, [pageInfo.pageIndex, pageInfo.pageSize]);
//   const getList = async () => {
//     setLoading(true);
//     try {
//       const res = await SpaceAPI.originalVideo({ ...pageInfo, type: 3 });
//       console.log(res);
//       if (res?.code === 0) {
//         const info = res.data.result;
//         setVideoList(info.rows);
//         setPageInfo((page) => ({
//           ...page,
//           total: info.totalRowCount || 0,
//         }));
//       }
//       if (res.data.result.rows.length <= 0 && pageInfo.pageIndex !== 0) {
//         setPageInfo((page) => ({ ...page, pageIndex: page.pageIndex - 1 }));
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setLoading(false);
//   };
//   const handlePagChange = (pageIndex, pageSize) => {
//     setPageInfo((page) => ({
//       ...page,
//       pageIndex: pageIndex - 1,
//       pageSize,
//     }));
//   };
//   return (
//     <div className="exported">
//       <div className="exported_title">{t('As_Space_Checkexportedproject')}</div>
//       <div className="data_show">
//         {loading ? (
//           <div className="loading_main">
//             <span className="loading loading-spinner loading-md text-neutral"></span>
//           </div>
//         ) : (
//           <AssetsVideo list={videoList} assetsList={getList} asExportist />
//         )}
//       </div>
//       {pageInfo.total > 12 && !loading && (
//         <RcPagination
//           current={pageInfo.pageIndex + 1}
//           defaultPageSize={pageInfo.pageSize}
//           total={pageInfo.total}
//           align="center"
//           showTitle={false}
//           onChange={handlePagChange}
//           prevIcon={
//             <button className={`rc-flip ${pageInfo.pageIndex === 0 && 'rc-disabled-flip'}`} />
//           }
//           nextIcon={
//             <button
//               className={`rc-flip ${pageInfo.pageIndex + 1 === Math.ceil(pageInfo.total / pageInfo.pageSize) && 'rc-disabled-flip'}`}
//             />
//           }
//         />
//       )}
//     </div>
//   );
// }
